import { Place } from '../types';

export const PLACES: Place[] = [
  {
    id: 'victoria-memorial',
    name: 'Victoria Memorial',
    category: 'heritage',
    subcategories: ['monument', 'historical', 'scenic'],
    latitude: 22.5448,
    longitude: 88.3426,
    area: 'Alipore',
    description: 'Iconic white marble monument dedicated to Queen Victoria. Stunning architecture and sprawling gardens make it perfect for couples.',
    dateVibes: ['romantic', 'photography', 'city-exploration'],
    romanticScore: 95,
    scenicScore: 98,
    cultureScore: 90,
    foodScore: 40,
    activityScore: 60,
    estimatedVisitDuration: 90,
    openingHours: { open: '10:00', close: '18:00' },
    entryFee: 100,
    estimatedSpend: 200,
    bestTime: ['morning', 'sunset'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Rabindra Sarovar',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Best during golden hour for photography. Gardens are spacious and peaceful despite crowds.'
  },
  {
    id: 'indian-museum',
    name: 'Indian Museum',
    category: 'museum',
    subcategories: ['art', 'history', 'cultural'],
    latitude: 22.5619,
    longitude: 88.3666,
    area: 'Park Street',
    description: 'One of Asia\'s oldest museums with extensive collections of art, artifacts, and natural history.',
    dateVibes: ['culture', 'intellectual', 'peaceful'],
    romanticScore: 70,
    scenicScore: 60,
    cultureScore: 98,
    foodScore: 30,
    activityScore: 50,
    estimatedVisitDuration: 120,
    openingHours: { open: '10:00', close: '17:30' },
    entryFee: 150,
    estimatedSpend: 200,
    bestTime: ['morning', 'early-afternoon'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Park Street',
    indoorOutdoor: 'indoor',
    crowdLevel: 'medium',
    verified: true,
    notes: 'Avoid Mondays (closed). Photography allowed in certain sections. Café inside.'
  },
  {
    id: 'prinsep-ghat',
    name: 'Prinsep Ghat',
    category: 'scenic',
    subcategories: ['riverside', 'sunset', 'photography'],
    latitude: 22.5656,
    longitude: 88.3648,
    area: 'Park Street',
    description: 'Historic ghat with stunning views of the Hooghly River. Iconic spot for sunset and evening walks.',
    dateVibes: ['romantic', 'sunset', 'peaceful', 'photography'],
    romanticScore: 98,
    scenicScore: 95,
    cultureScore: 75,
    foodScore: 50,
    activityScore: 40,
    estimatedVisitDuration: 60,
    openingHours: { open: '06:00', close: '22:00' },
    entryFee: 0,
    estimatedSpend: 100,
    bestTime: ['sunset', 'evening'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Park Street',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'medium',
    verified: true,
    notes: 'Best in the golden hour. Street vendors sell snacks. Bring camera for sunset shots.'
  },
  {
    id: 'college-street',
    name: 'College Street',
    category: 'shopping',
    subcategories: ['bookstore', 'street-exploration', 'cultural'],
    latitude: 22.5597,
    longitude: 88.3673,
    area: 'Central Kolkata',
    description: 'Historic street lined with independent bookstores, vintage shops, and intellectual cafés.',
    dateVibes: ['intellectual', 'city-exploration', 'shopping', 'culture'],
    romanticScore: 80,
    scenicScore: 70,
    cultureScore: 95,
    foodScore: 70,
    activityScore: 60,
    estimatedVisitDuration: 120,
    openingHours: { open: '09:00', close: '20:00' },
    entryFee: 0,
    estimatedSpend: 200,
    bestTime: ['morning', 'afternoon'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'College Street',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Best for book lovers. Many historic cafés. Great for walking exploration.'
  },
  {
    id: 'coffee-house',
    name: 'Coffee House',
    category: 'cafe',
    subcategories: ['historic-cafe', 'food', 'hangout'],
    latitude: 22.5612,
    longitude: 88.3668,
    area: 'College Street',
    description: 'Legendary café on College Street since 1876. Intellectual hub with literary history.',
    dateVibes: ['intellectual', 'peaceful', 'romantic'],
    romanticScore: 85,
    scenicScore: 70,
    cultureScore: 90,
    foodScore: 75,
    activityScore: 30,
    estimatedVisitDuration: 60,
    openingHours: { open: '07:00', close: '21:00' },
    entryFee: 0,
    estimatedSpend: 150,
    bestTime: ['morning', 'evening'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'College Street',
    indoorOutdoor: 'indoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Very crowded during peak hours. Great for conversations. Original literary hangout.'
  },
  {
    id: 'sealdah-station',
    name: 'Sealdah Railway Station',
    category: 'heritage',
    subcategories: ['transport', 'architecture', 'historic'],
    latitude: 22.5676,
    longitude: 88.3547,
    area: 'Central Kolkata',
    description: 'Historic railway station with colonial architecture. Gateway to local train exploration.',
    dateVibes: ['journey', 'city-exploration', 'architecture'],
    romanticScore: 65,
    scenicScore: 75,
    cultureScore: 80,
    foodScore: 60,
    activityScore: 40,
    estimatedVisitDuration: 30,
    openingHours: { open: '05:00', close: '23:00' },
    entryFee: 0,
    estimatedSpend: 20,
    bestTime: ['morning', 'early-evening'],
    transportAccess: ['metro', 'bus', 'local-train'],
    metroStation: 'Sealdah',
    railwayStation: 'Sealdah',
    indoorOutdoor: 'both',
    crowdLevel: 'high',
    verified: true,
    notes: 'Great for experiencing local transport. Interesting street food vendors.'
  },
  {
    id: 'alipore-zoo',
    name: 'Alipore Zoo',
    category: 'activity',
    subcategories: ['nature', 'family-friendly', 'outdoor'],
    latitude: 22.5378,
    longitude: 88.3364,
    area: 'Alipore',
    description: 'One of India\'s oldest zoos with diverse animal species and well-maintained grounds.',
    dateVibes: ['fun-activities', 'nature', 'peaceful'],
    romanticScore: 75,
    scenicScore: 80,
    cultureScore: 50,
    foodScore: 40,
    activityScore: 85,
    estimatedVisitDuration: 150,
    openingHours: { open: '09:00', close: '17:00' },
    entryFee: 100,
    estimatedSpend: 250,
    bestTime: ['morning'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Rabindra Sarovar',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Best in early morning. Closed Mondays. Very spacious, good for long walks.'
  },
  {
    id: 'millennium-park',
    name: 'Millennium Park',
    category: 'park',
    subcategories: ['nature', 'scenic', 'peaceful'],
    latitude: 22.5448,
    longitude: 88.3550,
    area: 'Alipore',
    description: 'Beautiful park along the Hooghly River with green spaces, walking paths, and city views.',
    dateVibes: ['peaceful', 'romantic', 'nature'],
    romanticScore: 90,
    scenicScore: 85,
    cultureScore: 40,
    foodScore: 50,
    activityScore: 60,
    estimatedVisitDuration: 75,
    openingHours: { open: '05:00', close: '21:00' },
    entryFee: 0,
    estimatedSpend: 100,
    bestTime: ['morning', 'sunset'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Rabindra Sarovar',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'low',
    verified: true,
    notes: 'Quiet and romantic. Great for sunset walks. Limited food options inside.'
  },
  {
    id: 'park-street',
    name: 'Park Street',
    category: 'shopping',
    subcategories: ['street-exploration', 'food', 'nightlife'],
    latitude: 22.5634,
    longitude: 88.3697,
    area: 'Park Street',
    description: 'Kolkata\'s bustling commercial street with restaurants, shops, and vibrant street life.',
    dateVibes: ['city-exploration', 'food-adventure', 'fun-activities'],
    romanticScore: 75,
    scenicScore: 65,
    cultureScore: 70,
    foodScore: 90,
    activityScore: 75,
    estimatedVisitDuration: 90,
    openingHours: { open: '09:00', close: '23:00' },
    entryFee: 0,
    estimatedSpend: 300,
    bestTime: ['evening', 'night'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Park Street',
    indoorOutdoor: 'both',
    crowdLevel: 'high',
    verified: true,
    notes: 'Very crowded in evenings. Best restaurants and cafés. Great for street exploration.'
  },
  {
    id: 'metcalfe-hall',
    name: 'Metcalfe Hall',
    category: 'heritage',
    subcategories: ['historic', 'architecture', 'cultural'],
    latitude: 22.5617,
    longitude: 88.3661,
    area: 'Park Street',
    description: 'Historic hall from 1840s. Grand architecture and cultural events venue.',
    dateVibes: ['culture', 'architecture', 'photography'],
    romanticScore: 70,
    scenicScore: 75,
    cultureScore: 85,
    foodScore: 30,
    activityScore: 50,
    estimatedVisitDuration: 45,
    openingHours: { open: '10:00', close: '18:00' },
    entryFee: 0,
    estimatedSpend: 50,
    bestTime: ['morning', 'afternoon'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Park Street',
    indoorOutdoor: 'indoor',
    crowdLevel: 'low',
    verified: true,
    notes: 'Check for events happening. Beautiful interior for photos.'
  },
  {
    id: 'howrah-bridge',
    name: 'Howrah Bridge',
    category: 'heritage',
    subcategories: ['landmark', 'photography', 'scenic'],
    latitude: 22.5741,
    longitude: 88.3473,
    area: 'Howrah',
    description: 'Historic cantilever bridge. Iconic structure with great city views from both banks.',
    dateVibes: ['photography', 'city-exploration', 'scenic'],
    romanticScore: 80,
    scenicScore: 95,
    cultureScore: 85,
    foodScore: 60,
    activityScore: 50,
    estimatedVisitDuration: 60,
    openingHours: { open: '00:00', close: '23:59' },
    entryFee: 0,
    estimatedSpend: 100,
    bestTime: ['sunset', 'evening'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Howrah',
    railwayStation: 'Howrah',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Best views at sunset. Walking the bridge is an experience. Crowded but worth it.'
  },
  {
    id: 'balusters-ghats',
    name: 'Balusters & River Ghats',
    category: 'scenic',
    subcategories: ['riverside', 'heritage', 'outdoor'],
    latitude: 22.5720,
    longitude: 88.3650,
    area: 'Central Kolkata',
    description: 'Series of historic ghats along the Hooghly with morning and evening activity.',
    dateVibes: ['romantic', 'peaceful', 'photography'],
    romanticScore: 85,
    scenicScore: 90,
    cultureScore: 75,
    foodScore: 50,
    activityScore: 40,
    estimatedVisitDuration: 75,
    openingHours: { open: '05:00', close: '21:00' },
    entryFee: 0,
    estimatedSpend: 100,
    bestTime: ['early-morning', 'sunset'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Park Street',
    indoorOutdoor: 'outdoor',
    crowdLevel: 'medium',
    verified: true,
    notes: 'Beautiful in early morning and sunset. Local life and ghats are alive.'
  },
  {
    id: 'nakhoda-mosque',
    name: 'Nakhoda Mosque',
    category: 'heritage',
    subcategories: ['religious', 'architecture', 'cultural'],
    latitude: 22.5659,
    longitude: 88.3618,
    area: 'Central Kolkata',
    description: 'Magnificent mosque from 1926 with Indo-Islamic architecture. One of the largest in India.',
    dateVibes: ['culture', 'architecture', 'photography'],
    romanticScore: 70,
    scenicScore: 75,
    cultureScore: 90,
    foodScore: 40,
    activityScore: 30,
    estimatedVisitDuration: 45,
    openingHours: { open: '06:00', close: '21:00' },
    entryFee: 0,
    estimatedSpend: 50,
    bestTime: ['afternoon'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Sealdah',
    indoorOutdoor: 'both',
    crowdLevel: 'medium',
    verified: true,
    notes: 'Respectful dress required. Beautiful courtyard and architecture. Less crowded than temples.'
  },
  {
    id: 'kali-temple',
    name: 'Kali Temple at Kalighat',
    category: 'heritage',
    subcategories: ['religious', 'cultural', 'historic'],
    latitude: 22.5186,
    longitude: 88.3631,
    area: 'Kalighat',
    description: 'Ancient temple dedicated to Goddess Kali. Spiritual hub and important pilgrimage site.',
    dateVibes: ['culture', 'spiritual'],
    romanticScore: 60,
    scenicScore: 65,
    cultureScore: 95,
    foodScore: 50,
    activityScore: 40,
    estimatedVisitDuration: 60,
    openingHours: { open: '05:00', close: '21:00' },
    entryFee: 0,
    estimatedSpend: 100,
    bestTime: ['morning'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Kalighat',
    indoorOutdoor: 'both',
    crowdLevel: 'high',
    verified: true,
    notes: 'Very crowded. Early morning visit recommended. Authentic cultural experience.'
  },
  {
    id: 'birla-planetarium',
    name: 'Birla Planetarium',
    category: 'museum',
    subcategories: ['science', 'activity', 'educational'],
    latitude: 22.5498,
    longitude: 88.3600,
    area: 'Alipore',
    description: 'State-of-the-art planetarium with shows about space and astronomy.',
    dateVibes: ['fun-activities', 'intellectual', 'indoor'],
    romanticScore: 75,
    scenicScore: 60,
    cultureScore: 70,
    foodScore: 30,
    activityScore: 80,
    estimatedVisitDuration: 120,
    openingHours: { open: '11:00', close: '19:00' },
    entryFee: 100,
    estimatedSpend: 200,
    bestTime: ['afternoon'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Rabindra Sarovar',
    indoorOutdoor: 'indoor',
    crowdLevel: 'medium',
    verified: true,
    notes: 'Shows in multiple languages. Book tickets online. Closed Mondays.'
  },
  {
    id: 'new-market',
    name: 'New Market',
    category: 'shopping',
    subcategories: ['shopping', 'street-food', 'haggling'],
    latitude: 22.5552,
    longitude: 88.3743,
    area: 'Central Kolkata',
    description: 'Historic market with vintage shops, boutiques, and street food vendors.',
    dateVibes: ['city-exploration', 'shopping', 'food-adventure'],
    romanticScore: 70,
    scenicScore: 65,
    cultureScore: 75,
    foodScore: 80,
    activityScore: 70,
    estimatedVisitDuration: 90,
    openingHours: { open: '10:00', close: '19:30' },
    entryFee: 0,
    estimatedSpend: 200,
    bestTime: ['late-morning', 'afternoon'],
    transportAccess: ['metro', 'bus', 'walking'],
    metroStation: 'Sealdah',
    indoorOutdoor: 'indoor',
    crowdLevel: 'high',
    verified: true,
    notes: 'Very crowded. Haggling is normal. Great street food options.'
  },
  {
    id: 'ramakrishna-mission',
    name: 'Ramakrishna Mission Institute of Culture',
    category: 'cultural',
    subcategories: ['spiritual', 'art', 'library'],
    latitude: 22.5575,
    longitude: 88.3585,
    area: 'Central Kolkata',
    description: 'Cultural institute with art gallery, library, and peaceful spiritual atmosphere.',
    dateVibes: ['peaceful', 'culture', 'intellectual'],
    romanticScore: 75,
    scenicScore: 70,
    cultureScore: 90,
    foodScore: 20,
    activityScore: 40,
    estimatedVisitDuration: 90,
    openingHours: { open: '10:00', close: '18:00' },
    entryFee: 50,
    estimatedSpend: 100,
    bestTime: ['morning', 'afternoon'],
    transportAccess: ['metro', 'bus'],
    metroStation: 'Rabindra Sarovar',
    indoorOutdoor: 'indoor',
    crowdLevel: 'low',
    verified: true,
    notes: 'Very quiet and peaceful. Beautiful library. Good escape from city chaos.'
  },
  {
    id: 'salt-lake',
    name: 'Salt Lake City Area',
    category: 'activity',
    subcategories: ['urban-exploration', 'mall', 'modern'],
    latitude: 22.5593,
    longitude: 88.4408,
    area: 'Salt Lake',
    description: 'Modern planned township with parks, malls, and restaurants. Newer Kolkata vibe.',
    dateVibes: ['city-exploration', 'fun-activities', 'food-adventure'],
    romanticScore: 70,
    scenicScore: 60,
    cultureScore: 40,
    foodScore: 85,
    activityScore: 80,
    estimatedVisitDuration: 120,
    openingHours: { open: '10:00', close: '22:00' },
    entryFee: 0,
    estimatedSpend: 300,
    bestTime: ['afternoon', 'evening'],
    transportAccess: ['metro'],
    metroStation: 'Salt Lake Stadium',
    indoorOutdoor: 'both',
    crowdLevel: 'high',
    verified: true,
    notes: 'Multiple malls and restaurants. Modern facilities. Very different from old Kolkata.'
  }
];

export const NEIGHBORHOODS = [
  { name: 'Jadavpur', lat: 22.4986, lng: 88.3825 },
  { name: 'Garia', lat: 22.4676, lng: 88.4174 },
  { name: 'Tollygunge', lat: 22.4883, lng: 88.3838 },
  { name: 'Salt Lake', lat: 22.5593, lng: 88.4408 },
  { name: 'Sealdah', lat: 22.5676, lng: 88.3547 },
  { name: 'Howrah', lat: 22.5741, lng: 88.3473 },
  { name: 'Behala', lat: 22.5057, lng: 88.3470 },
  { name: 'Dum Dum', lat: 22.6406, lng: 88.4470 },
  { name: 'New Town', lat: 22.5859, lng: 88.4668 },
  { name: 'Park Street', lat: 22.5634, lng: 88.3697 },
  { name: 'Alipore', lat: 22.5378, lng: 88.3364 },
  { name: 'Kalighat', lat: 22.5186, lng: 88.3631 },
];
